import { Link } from 'react-router-dom';
import { FOOTER_NAV_ITEMS, getFooterNavHref } from '../lib/siteNavigation';

export default function BlogFooter() {
  return (
    <footer className="mt-auto pt-10 pb-10 border-t border-white/10 text-center px-6">
      <div className="flex items-center justify-center gap-2 mb-8">
        <span className="text-xl">🔥</span>
        <span className="font-extrabold text-lg">OurSexQuiz</span>
      </div>
      <div className="flex justify-center gap-6 text-sm text-slate-400 font-medium mb-10">
        {FOOTER_NAV_ITEMS.map((item) => {
          const to = getFooterNavHref(item.key, 'blog');

          if (!to) return null;

          return (
            <Link key={item.key} to={to} className="hover:text-primary transition-colors">
              {item.label}
            </Link>
          );
        })}
      </div>
      <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/20">
        Made with ❤️ in Amsterdam
      </p>
    </footer>
  );
}
